var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretPrev = function SvgCaretPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 10.6 18.6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.3 10.2c-.5-.7-.2-1.4.3-2C1.9 6.8 6.9 1.5 8.2.4c1.4-1.2 3.2.5 2 1.9-.3.4-6.8 6.8-6.8 7 0 .3 6.7 6.8 7 7.2.9 1.5-1 2.7-2.2 1.7a99 99 0 0 1-7.9-8"
  })));
};
export default SvgCaretPrev;